import { z } from 'zod'

export const updateConductorSchema = z.object({
  licenciaCategoria: z.string().optional(),
  licenciaVencimiento: z.coerce.date().optional(),
  vehiculoActivoId: z.string().optional(),
})

export const vehiculoSchema = z.object({
  placa: z.string().regex(/^[A-Z]{3}\d{3,4}$/, 'Chapa inválida'),
  tipo: z.string().min(2).max(30), // validado contra ConfigVehiculoTipo no service
  marca: z.string().min(2).max(50),
  modelo: z.string().min(1).max(100),
  anio: z.number().int().min(1990).max(new Date().getFullYear() + 1),
  capacidadKg: z.number().int().positive(),
  capacidadM3: z.number().positive().optional(),
})

export type UpdateConductorInput = z.infer<typeof updateConductorSchema>
export type VehiculoInput = z.infer<typeof vehiculoSchema>
